export default function ProductPostPurchase() {
  return null
}
